import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';

const EntityStatusDto = t.type(
  {
    id: t.number,
    name: nullable(t.string),
    color: nullable(t.string),
  },
  'EntityStatusDto',
);

type EntityStatusDto = t.TypeOf<typeof EntityStatusDto>;
export { EntityStatusDto };
